import MenuCourse, { MenuCourseProps } from './MenuCourse';

export type { MenuCourseProps };
export default MenuCourse;
